import { useQuery } from 'react-query'

import { useLogger } from '@vp/ubik-context'

import type { RelatedProduct } from '../../types/RelatedProduct'
import { getRelatedProductsData } from '../../clients/BffClient'
import { STALE_TIME_INFINITY } from './constants'
import { useAppState } from '../../components/root/contexts/AppContext'
import { useTenant } from '../../components/root/contexts/TenantContext'

export const useRelatedProductsQuery = () => {
  const { culture, country, primaryProject, isAppStateInitialized } = useAppState()
  const { tenant, merchantId } = useTenant()
  const logger = useLogger()

  return useQuery<RelatedProduct[]>(
    ['related-products', tenant, primaryProject?.productKey],
    async () => {
      const relatedProducts = await getRelatedProductsData(
        tenant,
        merchantId,
        culture,
        country,
        primaryProject?.productKey as string,
        primaryProject?.work.merchandising.merchandisingSelections || {},
        primaryProject?.work.design.designUrl as string,
        logger,
      )
      return relatedProducts
    },
    {
      enabled: isAppStateInitialized && !!primaryProject && !!primaryProject.hasRelatedProducts,
      staleTime: STALE_TIME_INFINITY,
    },
  )
}
